import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSpousalSupportPayment } from "../../contexts/SpousalSupportPaymentContext";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../design/description-list";
import { Heading } from "../../design/heading";
import DeleteSpousalSupportPaymentButton from "./components/DeleteSpousalSupportPaymentButton";
import LoadingView from "../../components/LoadingView";
import EditSpousalSupportPaymentButton from "./components/EditSpousalSupportPaymentButton";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";
import { User } from "../../models/User";
import moment from "moment";
import SpousalSupportPaymentFilesList from "./components/Files/SpousalSupportPaymentFilesList";

const SpousalSupportPaymentDetailPage: React.FC = () => {
  const { spousalSupportPaymentId } = useParams<{
    spousalSupportPaymentId: string;
  }>();
  const {
    selectedSpousalSupportPayment,
    setSelectedSpousalSupportPayment,
    error,
    loading,
  } = useSpousalSupportPayment();

  useEffect(() => {
    if (spousalSupportPaymentId) {
      setSelectedSpousalSupportPayment(spousalSupportPaymentId);
    }
  }, [spousalSupportPaymentId]);

  if (loading.details) {
    return <LoadingView />;
  }

  if (error.details) {
    return <ErrorView error={error.details} />;
  }

  if (!selectedSpousalSupportPayment) {
    return <ErrorView error={new Error("SpousalSupportPayment not found")} />;
  }

  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Child Support", href: "/child-support" },
          {
            label: moment(selectedSpousalSupportPayment.date).format("LL"),
            href: `/child-support-payment/${selectedSpousalSupportPayment._id}`,
          },
        ]}
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-col w-full gap-6">
          <div className="mb-6">
            <div className="flex items-center justify-between">
              <Heading>
                {moment(selectedSpousalSupportPayment.date).format("LL")}
              </Heading>
              <div className="flex gap-2">
                <EditSpousalSupportPaymentButton
                  spousalSupportPayment={selectedSpousalSupportPayment}
                />
                <DeleteSpousalSupportPaymentButton
                  spousalSupportPaymentId={selectedSpousalSupportPayment._id}
                />
              </div>
            </div>
            <DescriptionList>
              {selectedSpousalSupportPayment.notes && (
                <>
                  <DescriptionTerm>Notes</DescriptionTerm>
                  <DescriptionDetails style={{ whiteSpace: "pre-line" }}>
                    {selectedSpousalSupportPayment.notes}
                  </DescriptionDetails>
                </>
              )}
            </DescriptionList>
          </div>
        </div>
      </div>

      <SpousalSupportPaymentFilesList
        spousalSupportPaymentId={selectedSpousalSupportPayment._id}
      />
    </div>
  );
};

export default SpousalSupportPaymentDetailPage;
